export const orgId = 80
export const baseUrl = 'http://www.scgxlc.com:4000/api/v1'
